module.exports = __webpack_public_path__ + "56299075b2c8626b407e73fb19129fe0.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-1080.webp
// module id = 373
// module chunks = 0